import { createContext, useContext, useState, useEffect, useMemo } from "react";

const messages = {
  en: {
    nav: {
      book: "Book",
      services: "Services",
      fleet: "Fleet",
      destinations: "Destinations",
      experiences: "Experiences",
      about: "About",
      contact: "Contact",
      quote: "Get a Quote",
      partner: "Become a Partner",
      driver: "Become a driver",
    },
    hero: {
      badge: "Available 24 / 7 in Split",
      title_a: "Private chauffeur.",
      title_b: "Dalmatian coast,",
      title_c: "effortlessly.",
      sub: "Premium private transfers from Split airport, intercity routes across Croatia, and curated private day tours. Discreet, on time, immaculately driven.",
      cta_book: "Request a Quote",
      cta_fleet: "Explore the Fleet",
      stat_rating: "★ 5.0 RATED",
      stat_trips: "FIXED PRICING",
      stat_since: "24/7 SUPPORT",
      scroll: "Scroll",
      driver_ribbon_prefix: "Are you a professional driver?",
      driver_ribbon_cta: "Join the Juke fleet",
    },
    form: {
      badge: "Instant Quote",
      title: "Request your transfer",
      tab_transfer: "Transfer",
      tab_hourly: "Hourly Charter",
      duration: "Duration",
      hours: "hours",
      hourly_vehicle_label: "Comfort Class (up to 4 passengers)",
      comfort_class_label: "Comfort Class (up to 4 passengers)",
      vehicle_class_eyebrow: "Vehicle Class",
      vehicle_class_helper: "All classes shown with their price — tap to change.",
      vehicle_class_comfort: "Comfort",
      vehicle_class_comfort_sub: "Up to 4 passengers",
      vehicle_class_xl: "XL Vehicle",
      vehicle_class_xl_sub: "6+1 passengers",
      vehicle_class_van: "Van",
      vehicle_class_van_sub: "8+1 passengers",
      vehicle_class_business: "Business Class",
      vehicle_class_business_sub: "Mercedes E-Class · up to 3",
      vehicle_class_vip_van: "VIP Luxury Van",
      vehicle_class_vip_van_sub: "Mercedes V-Class · up to 7",
      vehicle_class_from: "from",
      rate_vehicle_class: "Vehicle class",
      rate_min_fare: "Minimum fare applied",
      duration_fairuse: "Includes up to 25 km per booked hour for local travel & waiting. For long-distance intercity trips, please use the Transfer tab.",
      sticky_total_label: "Final Price",
      sticky_route_prefix: "Route",
      sticky_recalculating: "Recalculating…",
      sticky_book_now: "Book now",
      round_trip: "Round trip",
      round_trip_hint: "Return leg + waiting at destination",
      return_date: "Return Date",
      return_time: "Return Time",
      waiting_time: "Wait at Destination",
      waiting_none: "None",
      waiting_free: "included",
      waiting_at_dest: "wait at destination",
      waiting_included: "first 30 min free",
      rate_hourly_title: "Hourly Charter — Comfort Class",
      rate_hourly_short: "Rate",
      rate_round_trip_badge: "Round trip",
      rate_return_leg: "Return leg",
      sub: "Tell us where and when — we reply as soon as possible.",
      name: "Full Name",
      email: "Email",
      phone: "Phone",
      passengers: "Passengers",
      luggage: "Suitcases",
      pickup: "Pickup Location",
      dropoff: "Drop-off Location",
      date: "Pickup Date",
      time: "Pickup Time",
      vehicle: "Vehicle Type",
      notes: "Notes",
      notes_optional: "(optional)",
      vehicle_placeholder: "Choose your vehicle",
      notes_placeholder: "Flight number, luggage…",
      luggage_ph: "0",
      name_ph: "Ime Prezime",
      email_ph: "you@example.com",
      phone_ph: "+385 …",
      pickup_ph: "Split Airport (SPU)",
      dropoff_ph: "Hotel Park, Split",
      submit: "Request my quote",
      footer: "No payment now. We reply by email as soon as possible.",
      booking_model_note:
        "Juke Transfers operates both as a direct transport provider and as an online booking platform. Depending on the option offered at checkout, you will either pay a 20% non-refundable deposit online to Juke Transfers j.d.o.o. with the 80% balance paid in cash directly to the operating driver, or the 100% full amount online where applicable.",
      err_missing: "Please complete all required fields.",
      ok: "Inquiry sent. We'll reply with a quote shortly.",
      err_submit: "Could not send inquiry. Please try again.",
      quote_btn: "Get instant estimate",
      quote_btn_loading: "Calculating…",
      quote_distance: "Distance",
      quote_duration: "Approx. drive",
      quote_estimate: "Estimated price",
      quote_night: "Nighttime rates applied (22:00 – 06:00).",
      quote_luggage_line: "Includes suitcase fee at €1.00 per piece.",
      rate_day_title: "Daytime rate (06:00 – 22:00)",
      rate_night_title: "Nighttime rate (22:00 – 06:00)",
      rate_fixed_badge: "Fixed route",
      rate_start_fee: "Start fee",
      rate_suitcases: "suitcases",
      rate_fixed_line: "Published fixed price",
      rate_total: "Total",
      rate_fixed_night_note: "Fixed price includes +20% nighttime uplift.",
      rate_copy_btn: "Copy price breakdown",
      rate_copy_done: "Copied to clipboard",
      rate_copy_ok: "Price breakdown copied.",
      rate_copy_err: "Could not copy. Please copy manually.",
      rate_premium_transfer_line: "Premium Transfer Service (Includes Selected Comfort Add-ons)",
      flight_number: "Flight Number",
      flight_number_ph: "e.g. LH1338 or FR8342",
      flight_number_hint: "We'll track the flight and adjust pickup automatically if delayed >15 min.",
      upsell_eyebrow: "Enhance Your Ride",
      upsell_title: "Optional in-vehicle add-ons",
      upsell_selected: "selected",
      upsell_beverage_water: "Chilled Water",
      upsell_beverage_ice_coffee: "Chilled Ice Coffee",
      upsell_beverage_cola:       "Chilled Cola",
      upsell_beverage_beer:       "Chilled Local Beer",
      upsell_beverage_energy:     "Chilled Energy Drink",
      upsell_snack_box:           "Premium Snack Box",
      upsell_sim_card:            "Tourist 5G SIM Card",
      quote_disclaimer: "Indicative price based on driving distance. Final quote confirmed by email — fixed, no surge.",
      quote_err: "Could not estimate. Try a more specific address (e.g. 'Split Airport, Croatia').",
      whatsapp_book: "Book on WhatsApp",
      whatsapp_msg_intro: "Hello Juke Transfers, I'd like to book a transfer:",
      whatsapp_msg_route: "Route",
      whatsapp_msg_date: "Date / Time",
      whatsapp_msg_pax: "Passengers",
      whatsapp_msg_vehicle: "Vehicle",
      whatsapp_msg_estimate: "Estimated price",
    },
    services: {
      eyebrow: "Our Services",
      title: "Crafted for the discerning traveller.",
      sub: "From a five-minute airport pickup to a full week along the Dalmatian coast — every journey is chauffeur-driven, hand-detailed, and on your terms.",
      items: [
        { title: "Airport Transfers", body: "Meet & greet at Split, Zadar & Dubrovnik airports. Flight tracking, complimentary 60-min wait." },
        { title: "Intercity Transfers", body: "Direct routes along the Croatian coast, connecting major cities, coastal resorts, and ferry ports. Door-to-door, fixed pricing." },
        { title: "Private Day Tours", body: "Plitvice, Krka, Dubrovnik, and local Dalmatian gems – your itinerary, your pace, with an English-speaking driver." },
        { title: "Hourly Hire", body: "Chauffeur at your disposal for business meetings, weddings, or evenings in Split's old town." },
      ],
    },
    fleet: {
      eyebrow: "Our Fleet",
      title_a: "Our Modern ",
      title_b: "Fleet",
      sub: "Every vehicle is modern, eco-friendly, professionally detailed before each ride, and equipped with climate control for your maximum comfort.",
      book: "Book this vehicle",
      trust_caption: "You'll always be picked up in one of the vehicles shown above — every ride is Comfort Class.",
      cars: [
        { tagline: "Spacious crossover SUV combining comfort and efficiency.", passengers: "1–4 passengers", luggage: "3 large bags", perk: "Hybrid technology, Climate control" },
        { tagline: "Modern, eco-friendly compact SUV perfect for coastal roads.", passengers: "1–4 passengers", luggage: "2–3 bags", perk: "Hybrid efficiency, Bottled water" },
        { tagline: "Excellent legroom and class-leading trunk space for your luggage.", passengers: "1–4 passengers", luggage: "3 large bags", perk: "Smooth ride, Charging cables" },
      ],
    },
    dest: {
      eyebrow: "Where We Take You",
      title: "From Split — to anywhere worth going.",
      items: [
        { duration: "≈ 3h 15m", blurb: "The Pearl of the Adriatic — direct routes to Old Town." },
        { duration: "≈ 2h 30m", blurb: "UNESCO waterfalls and emerald lakes, all day." },
        { duration: "via ferry", blurb: "Yachts, lavender fields, and sunset rooftops." },
      ],
      routes_title: "Popular routes",
      routes_sub: "All-inclusive, no surge",
    },
    why: {
      eyebrow: "Why Juke Transfers",
      title: "A local team with a quiet obsession for detail.",
      body: "We were born in Split. Every driver knows the back-alley shortcut to the ferry terminal, the best espresso in Trogir, and exactly how long it really takes to reach Dubrovnik in August. We treat your trip like our own — only with better cars.",
      pillars: [
        { title: "Discreet & insured", body: "Fully licensed and fully insured. Professional local drivers focused on safe, smooth, and dependable rides for every guest." },
        { title: "On time, every time", body: "Fast email support. Flight tracking. We are at the kerb before you reach baggage claim." },
        { title: "Five-star fleet", body: "Modern, eco-friendly hybrid fleet. Pristine condition, fully air-conditioned, and sanitized between every ride." },
        { title: "Transparent pricing", body: "Quoted up front. No surge fees, no tolls, no surprises — just the price you agreed to." },
      ],
      stats: [
        { value: "5.0", label: "Average Rating" },
        { value: "Local", label: "Split Experts" },
        { value: "Fixed", label: "Pricing" },
        { value: "24/7", label: "Availability" },
      ],
    },
    test: {
      eyebrow: "Guests Say",
      google_eyebrow: "From Google Reviews",
      title: "Trusted by travellers who notice the details.",
      items: [
        { quote: "Booked a transfer from Split airport to our accommodation. The driver was waiting for us at the arrivals terminal, the vehicle was spotless and perfectly air-conditioned. Smooth and stress-free ride. We've stopped looking elsewhere.", name: "Eleanor R.", role: "London, UK" },
        { quote: "We've used Juke for three corporate trips in a row. Always on time, the vehicle is spotless, billing is painless. Easily the best in Dalmatia.", name: "Marcus L.", role: "Vienna" },
        { quote: "Booked a private tour to Krka National Park. The driver tailored the day around our schedule, knew every beautiful viewpoint, and was extremely helpful. Beyond a transfer — felt curated.", name: "The Larsen Family", role: "Copenhagen" },
      ],
    },
    contact: {
      eyebrow: "Contact",
      title: "Speak to a real concierge.",
      sub: "Tell us your dates and we'll arrange the rest. We answer in English and Croatian.",
      phone_label: "Phone & WhatsApp",
      email_label: "Email",
      based_label: "Based In",
      based_value: "Split, Dalmatia, Croatia",
      dispatch_label: "Dispatch",
      dispatch_value: "24 hours, 7 days a week",
      map_title: "Split, Croatia",
      map_sub: "Servicing all of Dalmatia, Istria, Zagreb, and cross-border to Montenegro, Bosnia & Slovenia.",
      hq_eyebrow: "Headquarters",
    },
    footer: {
      rights: "Licensed private transfer operator. All rights reserved.",
      admin: "Admin",
    },
  },

  hr: {
    nav: {
      book: "Rezerviraj",
      services: "Usluge",
      fleet: "Vozni park",
      destinations: "Destinacije",
      experiences: "Doživljaji",
      about: "O nama",
      contact: "Kontakt",
      quote: "Zatraži ponudu",
      partner: "Postani partner",
      driver: "Postani vozač",
    },
    hero: {
      badge: "Dostupni 24 / 7 u Splitu",
      title_a: "Privatni vozač.",
      title_b: "Dalmatinska obala,",
      title_c: "bez napora.",
      sub: "Premium privatni transferi sa splitske zračne luke, međugradske rute diljem Hrvatske i privatni dnevni izleti po mjeri. Diskretno, na vrijeme, besprijekorno vođeno.",
      cta_book: "Zatraži ponudu",
      cta_fleet: "Pogledaj vozni park",
      stat_rating: "★ 5.0 OCJENA",
      stat_trips: "FIKSNA CIJENA",
      stat_since: "24/7 PODRŠKA",
      scroll: "Skrolaj",
      driver_ribbon_prefix: "Jeste li profesionalni vozač?",
      driver_ribbon_cta: "Pridruži se Juke floti",
    },
    form: {
      badge: "Trenutna ponuda",
      title: "Zatražite svoj transfer",
      sub: "Recite nam gdje i kada — odgovaramo unutar 30 minuta.",
      name: "Ime i prezime",
      email: "E-mail",
      phone: "Telefon",
      passengers: "Putnici",
      luggage: "Kovčezi",
      pickup: "Lokacija preuzimanja",
      dropoff: "Lokacija dolaska",
      date: "Datum",
      time: "Vrijeme",
      vehicle: "Tip vozila",
      comfort_class_label: "Comfort klasa (do 4 putnika)",
      vehicle_class_eyebrow: "Klasa vozila",
      vehicle_class_helper: "Sve klase i cijene su prikazane — dodirnite za promjenu.",
      vehicle_class_comfort: "Comfort",
      vehicle_class_comfort_sub: "Do 4 putnika",
      vehicle_class_xl: "XL vozilo",
      vehicle_class_xl_sub: "6+1 putnika",
      vehicle_class_van: "Van",
      vehicle_class_van_sub: "8+1 putnika",
      vehicle_class_business: "Business klasa",
      vehicle_class_business_sub: "Mercedes E-klasa · do 3 putnika",
      vehicle_class_vip_van: "VIP luksuzni van",
      vehicle_class_vip_van_sub: "Mercedes V-klasa · do 7 putnika",
      vehicle_class_from: "od",
      rate_vehicle_class: "Klasa vozila",
      rate_min_fare: "Primijenjena minimalna tarifa",
      duration_fairuse: "Uključuje do 25 km po rezerviranom satu za lokalnu vožnju i čekanje. Za duža međugradska putovanja koristite karticu Transfer.",
      sticky_total_label: "Konačna cijena",
      sticky_route_prefix: "Ruta",
      sticky_recalculating: "Ponovno računam…",
      sticky_book_now: "Rezerviraj",
      notes: "Napomena",
      notes_optional: "(neobavezno)",
      vehicle_placeholder: "Odaberite vozilo",
      notes_placeholder: "Broj leta, prtljaga…",
      luggage_ph: "0",
      name_ph: "Ime Prezime",
      email_ph: "vi@primjer.com",
      phone_ph: "+385 …",
      pickup_ph: "Zračna luka Split (SPU)",
      dropoff_ph: "Hotel Park, Split",
      submit: "Zatraži ponudu",
      footer: "Bez plaćanja. Odgovaramo e-mailom u najkraćem mogućem roku.",
      booking_model_note:
        "Juke Transfers posluje istodobno kao izravni pružatelj prijevoza i kao online platforma za rezervacije. Ovisno o opciji odabranoj na naplati, platit ćete 20% nepovratnog predujma online tvrtki Juke Transfers j.d.o.o. uz preostalih 80% u gotovini izravno vozaču, ili 100% ukupnog iznosa online gdje je primjenjivo.",
      err_missing: "Molimo ispunite sva obavezna polja.",
      ok: "Upit poslan. Uskoro javljamo s ponudom.",
      err_submit: "Slanje nije uspjelo. Pokušajte ponovno.",
      quote_btn: "Izračunaj cijenu",
      quote_btn_loading: "Računam…",
      quote_distance: "Udaljenost",
      quote_duration: "Otprilike vožnja",
      quote_estimate: "Procijenjena cijena",
      quote_night: "Primijenjena noćna tarifa (22:00 – 06:00).",
      quote_luggage_line: "Uključuje naknadu za kovčege od 1,00 € po komadu.",
      rate_day_title: "Dnevna tarifa (06:00 – 22:00)",
      rate_night_title: "Noćna tarifa (22:00 – 06:00)",
      rate_fixed_badge: "Fiksna ruta",
      rate_start_fee: "Početna naknada",
      rate_suitcases: "kovčega",
      rate_fixed_line: "Objavljena fiksna cijena",
      rate_total: "Ukupno",
      rate_fixed_night_note: "Fiksna cijena uključuje +20% noćni dodatak.",
      rate_copy_btn: "Kopiraj razradu cijene",
      rate_copy_done: "Kopirano",
      rate_copy_ok: "Razrada cijene kopirana.",
      rate_copy_err: "Kopiranje nije uspjelo. Kopirajte ručno.",
      rate_premium_transfer_line: "Premium usluga transfera (uključuje odabrane comfort dodatke)",
      flight_number: "Broj leta",
      flight_number_ph: "npr. LH1338 ili FR8342",
      flight_number_hint: "Pratimo let i automatski prilagođavamo dolazak ako kasni >15 min.",
      upsell_eyebrow: "Nadogradite vožnju",
      upsell_title: "Neobavezni dodaci u vozilu",
      upsell_selected: "odabrano",
      upsell_beverage_water: "Hladna voda",
      upsell_beverage_ice_coffee: "Ledena kava",
      upsell_beverage_cola:       "Hladna kola",
      upsell_beverage_beer:       "Hladno domaće pivo",
      upsell_beverage_energy:     "Hladno energetsko piće",
      upsell_snack_box:           "Premium grickalice",
      upsell_sim_card:            "Turistička 5G SIM kartica",
      quote_disclaimer: "Okvirna cijena na temelju udaljenosti. Konačnu ponudu šaljemo e-mailom — fiksna, bez iznenađenja.",
      quote_err: "Ne mogu izračunati. Pokušajte specifičniju adresu (npr. 'Zračna luka Split, Hrvatska').",
      whatsapp_book: "Rezerviraj putem WhatsApp-a",
      whatsapp_msg_intro: "Pozdrav Juke Transfers, želim rezervirati transfer:",
      whatsapp_msg_route: "Ruta",
      whatsapp_msg_date: "Datum / Vrijeme",
      whatsapp_msg_pax: "Putnici",
      whatsapp_msg_vehicle: "Vozilo",
      whatsapp_msg_estimate: "Procijenjena cijena",
    },
    services: {
      eyebrow: "Naše usluge",
      title: "Stvoreno za zahtjevnog putnika.",
      sub: "Od petominutnog preuzimanja sa zračne luke do cijelog tjedna po dalmatinskoj obali — svako putovanje je voženo profesionalnim vozačem, brižno detaljizirano i prilagođeno vama.",
      items: [
        { title: "Transferi sa zračne luke", body: "Dočekujemo vas u zračnim lukama Split, Zadar i Dubrovnik. Praćenje leta, besplatno čekanje 60 min." },
        { title: "Međugradski transferi", body: "Direktne rute uz hrvatsku obalu, povezujući gradove, ljetovališta i trajektne luke. Od vrata do vrata, fiksna cijena." },
        { title: "Privatni dnevni izleti", body: "Plitvice, Krka, Dubrovnik i dalmatinski biseri — vaš itinerar, vaš tempo, s vozačem koji govori engleski." },
        { title: "Najam na sat", body: "Vozač vama na raspolaganju za poslovne sastanke, vjenčanja ili večeri u staroj jezgri Splita." },
      ],
    },
    fleet: {
      eyebrow: "Naš vozni park",
      title_a: "Naš moderni ",
      title_b: "vozni park",
      sub: "Svako vozilo je moderno, ekološki prihvatljivo, profesionalno detaljizirano prije svake vožnje, te opremljeno klimom za maksimalan komfor.",
      book: "Rezerviraj ovo vozilo",
      trust_caption: "Uvijek vas preuzimamo jednim od vozila prikazanih iznad — svaka vožnja je Comfort klasa.",
      cars: [
        { tagline: "Prostrani crossover SUV koji spaja udobnost i učinkovitost.", passengers: "1–4 putnika", luggage: "3 velike torbe", perk: "Hibridna tehnologija, Klima uređaj" },
        { tagline: "Moderan, ekološki kompaktni SUV idealan za obalne ceste.", passengers: "1–4 putnika", luggage: "2–3 torbe", perk: "Hibridna efikasnost, Voda u boci" },
        { tagline: "Izvrsna prostranost i klasno vodeći prtljažnik.", passengers: "1–4 putnika", luggage: "3 velike torbe", perk: "Tih i ugodan vožnja, Kabeli za punjenje" },
      ],
    },
    dest: {
      eyebrow: "Kamo vas vozimo",
      title: "Iz Splita — do svega što vrijedi vidjeti.",
      items: [
        { duration: "≈ 3h 15min", blurb: "Biser Jadrana — direktne rute do Starog Grada." },
        { duration: "≈ 2h 30min", blurb: "UNESCO slapovi i smaragdna jezera, cijeli dan." },
        { duration: "preko trajekta", blurb: "Jahte, polja lavande i krovne terase pri zalasku." },
      ],
      routes_title: "Popularne rute",
      routes_sub: "Sve uključeno, bez iznenađenja",
    },
    why: {
      eyebrow: "Zašto Juke Transfers",
      title: "Lokalni tim s tihom opsesijom za detalje.",
      body: "Rođeni smo u Splitu. Svaki vozač zna prečac do trajektne luke, najbolji espresso u Trogiru i koliko zaista traje put do Dubrovnika u kolovozu. Vaše putovanje tretiramo kao vlastito — samo s boljim autima.",
      pillars: [
        { title: "Diskretno i osigurano", body: "Potpuno licencirani i osigurani. Profesionalni lokalni vozači posvećeni sigurnoj, ugodnoj i pouzdanoj vožnji za svakog gosta." },
        { title: "Točno, svaki put", body: "Brza podrška e-mailom. Praćenje leta. Stižemo prije nego dođete do prtljage." },
        { title: "Vozni park s pet zvjezdica", body: "Moderna, ekološki prihvatljiva hibridna flota. Besprijekorno stanje, potpuno klimatizirana i dezinficirana između svake vožnje." },
        { title: "Transparentne cijene", body: "Ponuda unaprijed. Bez dodatnih naknada, bez cestarina, bez iznenađenja — samo dogovorena cijena." },
      ],
      stats: [
        { value: "5,0", label: "Prosječna ocjena" },
        { value: "Lokalni", label: "Stručnjaci za Split" },
        { value: "Fiksne", label: "Cijene" },
        { value: "24/7", label: "Dostupnost" },
      ],
    },
    test: {
      google_eyebrow: "S Google recenzija",
      eyebrow: "Gosti kažu",
      title: "Vjeruju nam putnici koji primjećuju detalje.",
      items: [
        { quote: "Rezervirali smo transfer sa splitske zračne luke do našeg smještaja. Vozač nas je dočekao u dolaznom terminalu, vozilo je bilo besprijekorno čisto i savršeno klimatizirano. Ugodna i potpuno bezbrižna vožnja. Više ne tražimo drugdje.", name: "Eleanor R.", role: "London, UK" },
        { quote: "Koristimo Juke za tri uzastopna poslovna putovanja. Uvijek na vrijeme, vozilo besprijekorno, naplata jednostavna. Najbolji u Dalmaciji.", name: "Marcus L.", role: "Beč" },
        { quote: "Rezervirali smo privatni izlet u Nacionalni park Krka. Vozač je dan prilagodio našem rasporedu, znao je svaki prekrasan vidikovac i bio je iznimno susretljiv. Više od transfera — pravo kustosko iskustvo.", name: "Obitelj Larsen", role: "Kopenhagen" },
      ],
    },
    contact: {
      eyebrow: "Kontakt",
      title: "Razgovarajte sa pravim concierge timom.",
      sub: "Recite nam datume, sve ostalo dogovaramo mi. Odgovaramo na engleskom i hrvatskom.",
      phone_label: "Telefon i WhatsApp",
      email_label: "E-mail",
      based_label: "Sjedište",
      based_value: "Split, Dalmacija, Hrvatska",
      dispatch_label: "Dispečerska",
      dispatch_value: "24 sata, 7 dana u tjednu",
      map_title: "Split, Hrvatska",
      map_sub: "Pokrivamo cijelu Dalmaciju, Istru, Zagreb i prekogranično Crnu Goru, BiH i Sloveniju.",
      hq_eyebrow: "Sjedište",
    },
    footer: {
      rights: "Licencirani operater privatnog prijevoza. Sva prava pridržana.",
      admin: "Admin",
    },
  },
};

const LangContext = createContext({ lang: "en", setLang: () => {}, t: (k) => k });

function resolve(obj, path) {
  return path.split(".").reduce((acc, key) => (acc && acc[key] !== undefined ? acc[key] : undefined), obj);
}

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("juke_lang") || "en");

  useEffect(() => {
    localStorage.setItem("juke_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = useMemo(() => {
    const dict = messages[lang] || messages.en;
    return (key) => {
      const val = resolve(dict, key);
      if (val === undefined) return resolve(messages.en, key) ?? key;
      return val;
    };
  }, [lang]);

  return <LangContext.Provider value={{ lang, setLang, t }}>{children}</LangContext.Provider>;
}

export function useLang() {
  return useContext(LangContext);
}

export const PHONE_DISPLAY = "+385 98 934 4079";
export const PHONE_TEL = "+385989344079";
export const WHATSAPP_NUMBER = "385989344079";
